
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agreement/recruit",
      function () {
        return require("private-next-pages/agreement/recruit.tsx");
      }
    ]);
  